import Block from './Block'
import styles from '../util/styleMap'
import GoogleMapsLoader from 'google-maps'

export default class Map extends Block {
    constructor(el, destroyLast) {
        super(el, destroyLast)

        this.currentMarker = null
        this.oldMarker = this.currentMarker
        this.mapZoom = 8
    }

    bindMethods() {
        this.initGoogleMap = this.initGoogleMap.bind(this)
        this.onGoogleMapError = this.onGoogleMapError.bind(this)
    }

    getElems() {
        this.map = this.el
        this.DOMMarkers = this.el.querySelectorAll('.marker')
    }

    onEnterCompleted() {
        GoogleMapsLoader.KEY = this.map.dataset.key
        GoogleMapsLoader.LIBRARIES = ['places']
        GoogleMapsLoader.LANGUAGE = 'fr'
        GoogleMapsLoader.VERSION = '3.37';
        GoogleMapsLoader.load(this.initGoogleMap)
    }

    initGoogleMap(googleMaps) {
        this.googleMapApi = googleMaps.maps
        this.googleMap = new this.googleMapApi.Map(this.map, {
            center: {
                lat: 45.7578137,
                lng: 4.8320114
            },
            zoom: this.mapZoom,
            streetViewControl: false,
            styles
        })

        this.googleMap.markers = []

        this.addMarkers()
        this.centerMap()
    }

    addMarkers() {
        for (let i = 0; i < this.DOMMarkers.length; i++) this.addMarker(this.DOMMarkers[i])
    }

    addMarker(DOMMarker) {
        const image = {
            url: '/wp-content/themes/digitalcover/resources/assets/images/svg/pin.svg',
            size: new this.googleMapApi.Size(20, 20),
            scaledSize: new this.googleMapApi.Size(20, 20),
            origin: new this.googleMapApi.Point(0, 0)
        }
        const infowindow = new google.maps.InfoWindow({
          content: DOMMarker.dataset.title
        });

        const marker = new this.googleMapApi.Marker({
            map: this.googleMap,
            icon: image,
            position: new this.googleMapApi.LatLng(
                DOMMarker.dataset.lat,
                DOMMarker.dataset.lng
            )
        })

        marker.addListener('click', () => {
          infowindow.open(this.map, marker);
        });

        this.googleMap.markers.push(marker)
    }

    onGoogleMapError(error) {
        console.error(error)
    }

    centerMap({lat, lng} = {}) {
        if (lat && lng) {
            const bounds = new this.googleMapApi.LatLngBounds()

            bounds.extend(new this.googleMapApi.LatLng(lat, lng))

            this.googleMap.setCenter(bounds.getCenter())
            // this.googleMap.setZoom(17)

            return
        }
        if (!this.bounds) this.bounds = new this.googleMapApi.LatLngBounds()

        for (let i = 0; i < this.googleMap.markers.length; i++) {
            const marker = this.googleMap.markers[i];
            const latlng = new this.googleMapApi.LatLng(
                marker.position.lat(),
                marker.position.lng()
            )

            this.bounds.extend(latlng)
        }

        if (this.googleMap.markers.length === 1) {
            this.googleMap.setCenter(this.bounds.getCenter())
            // this.googleMap.setZoom(14)
        } else this.googleMap.fitBounds(this.bounds)
    }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Map.js